module.exports = __webpack_public_path__ + "static/img/100_fot_contact.e13149f.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/100_fot_contact.jpeg
// module id = uQk3
// module chunks = 1